import { CONTENT_MAX_WIDTH } from '../../constants/base';

export function getCarouselPadding(width?: number) {
  const padding = ((width || window.innerWidth) - CONTENT_MAX_WIDTH) / 2 - 55;

  return padding > 0 ? padding : 0;
}
